/**
 * Public site shell + routing. The premium marketing site (Home) plus dedicated pages:
 * the full Served wall, public case proof chains, transparency and about. Donations are
 * collected manually (bank transfer / UPI / in person) via a pledge form.
 */
import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ScrollProgress } from './components/layout/ScrollProgress.jsx';
import { Header } from './components/layout/Header.jsx';
import { Footer } from './components/layout/Footer.jsx';
import ScrollToTop from './components/layout/ScrollToTop.jsx';
import { RouteFallback } from './components/layout/RouteFallback.jsx';
import Home from './pages/Home.jsx';

// Code-split heavier routes (recharts / leaflet stay out of the initial bundle).
const ServedWall = lazy(() => import('./pages/ServedWall.jsx'));
const ServedDetail = lazy(() => import('./pages/ServedDetail.jsx'));
const Transparency = lazy(() => import('./pages/Transparency.jsx'));
const About = lazy(() => import('./pages/About.jsx'));
const Donate = lazy(() => import('./pages/Donate.jsx'));
const DonorDashboard = lazy(() => import('./pages/DonorDashboard.jsx'));
const Contact = lazy(() => import('./pages/Contact.jsx'));
const ProgramsPage = lazy(() => import('./pages/ProgramsPage.jsx'));
const GetInvolvedPage = lazy(() => import('./pages/GetInvolvedPage.jsx'));
const FaqPage = lazy(() => import('./pages/FaqPage.jsx'));
const NotFound = lazy(() => import('./pages/NotFound.jsx'));

export default function App() {
  return (
    <>
      <a href="#main" className="skip-link">
        Skip to content
      </a>
      <ScrollProgress />
      <ScrollToTop />
      <Header />
      <main id="main">
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/served" element={<ServedWall />} />
            <Route path="/served/:caseId" element={<ServedDetail />} />
            <Route path="/transparency" element={<Transparency />} />
            <Route path="/about" element={<About />} />
            <Route path="/programs" element={<ProgramsPage />} />
            <Route path="/get-involved" element={<GetInvolvedPage />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/donor" element={<DonorDashboard />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </>
  );
}
